import Vue from 'vue';
import App from './App.vue';
import VueRouter from "vue-router";
import router from './router';
import store from './store';
import './assets/css/global.less';
//全局组件-三级联动
/*import TypeNav from '@/components/TypeNav';
import Carousel from '@/components/Carousel';
import Pagination from '@/components/Pagination';*/
/*import {Button, MessageBox, Dropdown, DropdownMenu, DropdownItem, Menu} from "element-ui";

Vue.component(TypeNav.name, TypeNav);
Vue.component(Carousel.name, Carousel);
Vue.component(Pagination.name, Pagination);
Vue.component(Button.name, Button);
Vue.component(Dropdown.name, Dropdown);
Vue.component(DropdownMenu.name, DropdownMenu);
Vue.component(DropdownItem.name, DropdownItem);
Vue.component(Menu)*/

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
//ElementUI注册组件的时候，还有一种写法，挂在原型上
/*Vue.prototype.$msgbox = ElementUI.MessageBox;
Vue.prototype.$alert = ElementUI.MessageBox.alert;*/
//引入MockServe.js

import './assets/iconfont/iconfont.css';

import '@/mock/mockServe';
import 'swiper/css/swiper.min.css';
import 'element-ui/lib/theme-chalk/display.css';
//统一引入
import * as API from '@/api';
// import VueLazyload from "vue-lazyload";
// import atm from '@/assets/lazy.gif';

import mixins from "@/mixins";
Vue.mixin(mixins)

//引入自定义插件
// import myPlugin from "@/plugins/myPlugin";

Vue.config.productionTip = false
Vue.use(VueRouter);
/*Vue.use(VueLazyload, {
  loading:atm,
});*/

// Vue.use(myPlugin, {name: 'hello'});

//引入表单校验插件
import "@/plugins/validate";

new Vue({
  render: h => h(App),
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this;
    Vue.prototype.$API = API;
    // store.dispatch('setIsMobile')
  }
}).$mount('#app')
